import React, { useState, useRef } from 'react';
import DetectionOverlay from './DetectionOverlay';
import ColorLegend from './ColorLegend';
import './ImageUpload.css';

const API_URL = 'https://cv.ainnect.me';

const ImageUpload = ({ selectedModel }) => {
    const [image, setImage] = useState(null);
    const [detections, setDetections] = useState(null);
    const [isDetecting, setIsDetecting] = useState(false);
    const [error, setError] = useState(null);
    const fileInputRef = useRef(null);
    const imageRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setImage(e.target.result);
                setDetections(null);
                setError(null);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleDetect = async () => {
        if (!image || !fileInputRef.current.files[0]) return;

        setIsDetecting(true);
        setError(null);

        try {
            const formData = new FormData();
            formData.append('image', fileInputRef.current.files[0]);

            const response = await fetch(`${API_URL}/detect?model=${selectedModel || 'best_v8s'}`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`Server error: ${response.status}`);
            }

            const result = await response.json();
            setDetections(result);
        } catch (err) {
            console.error('Detection error:', err);
            setError(err.message);
        } finally {
            setIsDetecting(false);
        }
    };

    return (
        <div className="image-upload-container">
            <div className="upload-controls">
                <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                    className="file-input"
                />
                <button
                    onClick={handleDetect}
                    disabled={!image || isDetecting}
                    className="detect-btn"
                >
                    {isDetecting ? 'Đang xử lý...' : 'Phát hiện'}
                </button>
            </div>

            {error && <div className="error-message">{error}</div>}

            {image && (
                <div className="image-preview-wrapper">
                    <img
                        ref={imageRef}
                        src={image}
                        alt="Upload preview"
                        className="image-preview"
                    />
                    {detections && (
                        <DetectionOverlay
                            detections={detections.boxes}
                            imageWidth={detections.image.width}
                            imageHeight={detections.image.height}
                            videoWidth={imageRef.current?.clientWidth}
                            videoHeight={imageRef.current?.clientHeight}
                        />
                    )}
                </div>
            )}

            {detections && <ColorLegend detections={detections.boxes} />}
        </div>
    );
};

export default ImageUpload;
